import { render, staticRenderFns } from "./SocialButton.vue?vue&type=template&id=15866d7a&scoped=true"
import script from "./SocialButton.vue?vue&type=script&lang=js"
export * from "./SocialButton.vue?vue&type=script&lang=js"
import style0 from "./SocialButton.vue?vue&type=style&index=0&id=15866d7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15866d7a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/var/www/tubber-new/components/global/Button.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
